import React, { useEffect, useState } from "react";
import AutoSave from "../../../components/forms/AutoSave";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { setWpsOrderAmount } from "../../../store";
import Alert from "../../../components/Alert";
import { Link } from "react-router-dom";
import { wpsDiscountMessageCorps } from "../../../configlink";

const Estimate = ({ page, handleNextPage, handlePrevPage, progress }) => {
  const wpsWhole = useSelector((state) => state.wpsForm);
	const user2 = useSelector((state) => state.user.user)
	
  const data = wpsWhole.data 
  const tableData = wpsWhole.data.tableData 

  const dispatch = useDispatch()

  const reviewWarning = () => {
    return (
      <div className=' bg-[#0091EA] bg-opacity-15 rounded-md flex items-center py-6 px-4 h-[72px] mt-4 mb-10'>
        <div>
          <IoMdInformationCircleOutline className='text-2xl text-[#076DAC] m-3' />
        </div>
        <p className='font-semibold text-xl text-[#076DAC]'>
          <b>This is an estimate.</b> Final amount is subject to change.
        </p>
      </div>
    );
  };


  let wpsPrices = useSelector((state) => state.user.prices)
  // console.log("WPS Prices", wpsPrices);
  

  let standard = wpsPrices.find(x => x.Item === 'wps_standard') ? wpsPrices.find(x => x.Item === 'wps_standard').Price : 12
  let large = wpsPrices.find(x => x.Item === 'wps_large') ? wpsPrices.find(x => x.Item === 'wps_large').Price : 24
  let verylarge = wpsPrices.find(x => x.Item === 'wps_veryLarge') ? wpsPrices.find(x => x.Item === 'wps_veryLarge').Price : 48
	let culture = wpsPrices.find(x => x.Item === 'wps_culture') ? wpsPrices.find(x => x.Item === 'wps_culture').Price : 2.5 
	
  // let standard = 12
  // let large = 24
  // let verylarge = 48
	// let culture = 3
  // console.log(tableData);
  

  let count11 = 0     // standard -- plasmid (1)
  let count12 = 0     // standard -- amplicon/fragment (2)
  let count13 = 0     // standard -- culture
  
  let count21 = 0     // large  -- plasmid
  let count22 = 0     // large  -- amplicon
  let count23 = 0     // large  -- culture
 
  let count31 = 0     // verylarge  -- plasmid
  let count32 = 0     // verylarge  -- amplicon
  let count33 = 0     // verylarge  -- culture
 

  if(tableData.length>0){
    
    for(let i=0; i< tableData.length; i++){
      if(tableData[i].sampleType.value === 1){ 
        if(Number(tableData[i].targetSize) <= 25){
          count11++
        }
        else if(Number(tableData[i].targetSize) > 25 && Number(tableData[i].targetSize) <= 125){
          count21++
        }
        else if(Number(tableData[i].targetSize) > 125 && Number(tableData[i].targetSize) <= 200){
          count31++
        }
      }
      else if(tableData[i].sampleType.value === 2){ 
        if(Number(tableData[i].targetSize) <= 25){
          count12++
        }
        else if(Number(tableData[i].targetSize) > 25 && Number(tableData[i].targetSize) <= 125){
          count22++
        }
        else if(Number(tableData[i].targetSize) > 125 && Number(tableData[i].targetSize) <= 200){
          count32++
        }
      }
		else if(tableData[i].sampleType.value === 3){ 
        if(Number(tableData[i].targetSize) <= 25){
			count13++
        }
        else if(Number(tableData[i].targetSize) > 25 && Number(tableData[i].targetSize) <= 125){
			count23++
        }
        else if(Number(tableData[i].targetSize) > 125 && Number(tableData[i].targetSize) <= 200){
			count33++
        }
      }
      
    }
    
    
  }


  function getTotal(){
    let total = 0

    if(count11 > 0){
        total += standard * count11
    }
    if(count12 > 0){
        total += standard * count12
    }
	if(count13 > 0){
		total += (Number(standard) + Number(culture)) * count13
	}
    if(count21 > 0){
      total += large * count21
    }
    if(count22 > 0){
      total += large * count22
    }
	if(count23 > 0){
		total += (Number(large) + Number(culture)) * count23
    }
    if(count31 > 0){
      total += verylarge * count31
    }
    if(count32 > 0){
      total += verylarge * count32
    }
	if(count33 > 0){
		total += (Number(verylarge) + Number(culture)) * count33
	}
       

    dispatch(setWpsOrderAmount(total))

    return total

  }

  let [draftSuccess,setDraftSuccess] = useState(false)

  const passMessage = (message) => {
    // console.log("message");
    
    if(message === 'success'){
      window.scrollTo({top:200, left:0, behavior:'smooth'})
      setDraftSuccess(true)
      setTimeout(() => {
        setDraftSuccess(false)
      }, 5000)
    }
    else if(message === 'failure'){
      alert("Something went wrong..")
    }
  }

  return (
    <>
      <div className='px-8 xl:px-16'>
        <h1 className='text-3xl xl:text-4xl text-[var(--color-primary-purple)] font-black my-[40px]'>
          Whole Plasmid Sequencing 
        </h1>
        {draftSuccess && 
          <div className="mb-3">
            <Alert type="success">
              <span className="whitespace-nowrap">Form successfully saved to drafts. You can find your saved drafts by going to <Link to="/orderhistory" className="underline">My Orders.</Link></span>
            </Alert>
          </div>
          }
        <div className="w-full overflow-hidden">
          {progress}
          </div>
		
			<div className=' bg-yellow-100 rounded-md flex items-center py-6 px-12 mt-4'>
				<p className='font-semibold text-[15px] text-orange-600'>
					<b className="text-xl">10 or More WPS Reactions Receive 50% OFF</b> <br/>
					*Can be redeemed up to 10 times. Limited time only.
				</p>
			</div>
		
		{reviewWarning()}

        <table className='w-full'>
          <thead>
            <tr className='bg-[#000000] bg-opacity-[4%] h-[62px]'>
              <td className=' h-[44px] border-[1px] border-[#D5D5D8]  pl-3 font-bold'>
                Item Description
              </td>
              <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-bold'>
                Price Per Unit
              </td>
              <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-bold'>
                Quantity
              </td>
              <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-bold'>
                Subtotal
              </td>
            </tr>
          </thead>

          <tbody>
            {count11 > 0 && 
              <tr>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  Plasmid -- Standard
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                 ${Number(standard).toFixed(2)}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  {count11}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                {`$${(standard * count11).toFixed(2)}`}
                </td>
              </tr>
            }
            {count12 > 0 && 
              <tr>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  DNA fragment {">"} 1 Kb -- Standard
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                 ${Number(standard).toFixed(2)}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  {count12}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                {`$${(standard * count12).toFixed(2)}`}
                </td>
              </tr>
			}
			{count13 > 0 && 
				<tr>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						Culture -- Standard
					</td>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						${(Number(standard)+Number(culture)).toFixed(2)}
					</td>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						{count13}
					</td>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						{`$${((Number(standard)+Number(culture)) * count13).toFixed(2)}`}
					</td>
				</tr>
			}
            {count21 > 0 && 
              <tr>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  Plasmid -- Large
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                 ${Number(large).toFixed(2)}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  {count21}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                {`$${(large * count21).toFixed(2)}`}
                </td>
              </tr>
            }
            {count22 > 0 && 
              <tr>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  DNA fragment {">"} 1 Kb -- Large
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                 ${Number(large).toFixed(2)}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  {count22}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                {`$${(large * count22).toFixed(2)}`}
                </td>
              </tr>
			}
			{count23 > 0 && 
				<tr>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						Culture -- Large
					</td>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						${(Number(large)+Number(culture)).toFixed(2)}
					</td>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						{count23}
					</td>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						{`$${((Number(large)+Number(culture)) * count23).toFixed(2)}`}
					</td>
				</tr>
			}
            {count31 > 0 && 
              <tr>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  Plasmid -- Very Large
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                 ${Number(verylarge).toFixed(2)}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  {count31}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                {`$${(verylarge * count31).toFixed(2)}`}
                </td>
              </tr>
            }
            {count32 > 0 && 
              <tr>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  DNA fragment {">"} 1 Kb -- Very Large
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                 ${Number(verylarge).toFixed(2)}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                  {count32}
                </td>
                <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
                {`$${(verylarge * count32).toFixed(2)}`}
                </td>
              </tr>
			}
			{count33 > 0 && 
				<tr>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						Culture -- Very Large
					</td>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						${(Number(verylarge)+Number(culture)).toFixed(2)}
					</td>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						{count33}
					</td>
					<td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-semibold'>
						{`$${((Number(verylarge)+Number(culture)) * count33).toFixed(2)}`}
					</td>
				</tr>
			}
            
            
            <tr>
              <td className=' h-[44px] border-[1px] border-[#D5D5D8] bg-[#302b7e] bg-opacity-20 pl-3 font-bold text-[#302b7e]'>
                Total
              </td>
              <td className=' h-[44px] border-[1px] border-[#D5D5D8] bg-[#302b7e] bg-opacity-20 pl-3 font-semibold'></td>
              <td className=' h-[44px] border-[1px] border-[#D5D5D8] bg-[#302b7e] bg-opacity-20 pl-3 font-semibold'></td>
              <td className=' h-[44px] border-[1px] border-[#D5D5D8] pl-3 font-bold  text-[#302b7e]'>
                ${getTotal().toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
  
      </div>

      <AutoSave
        currentOrderForm={wpsWhole}
        page={page}
        handleNextPage={handleNextPage}
        handlePrevPage={handlePrevPage}
        steps={5}
        passMessage={passMessage}
      />
    </>
  );
};

export default Estimate;
